/**
 * @generated SignedSource<<2017003cd6820596c6554c69f156b7b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type _FilterOp = "EQUAL" | "IN" | "IS_SET" | "LIKE" | "%future added value";
export type _SortOrder = "ASC" | "DESC" | "%future added value";
export type _SortInput = {
  field: string;
  order: _SortOrder;
};
export type _FilterInput = {
  and?: ReadonlyArray<_FilterInput> | null;
  field?: string | null;
  label?: string | null;
  op?: _FilterOp | null;
  or?: ReadonlyArray<_FilterInput> | null;
  value?: any | null;
};
export type useViewerQuery$variables = {
  filter?: _FilterInput | null;
  limit?: number | null;
  numberOfTasks?: number | null;
  page?: number | null;
  taskSort?: ReadonlyArray<_SortInput> | null;
  tenantIds?: ReadonlyArray<string> | null;
};
export type useViewerQuery$data = {
  readonly viewer: {
    readonly id: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"useTasks_tasks">;
  } | null;
};
export type useViewerQuery = {
  response: useViewerQuery$data;
  variables: useViewerQuery$variables;
};
const node: ConcreteRequest = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "limit"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "numberOfTasks"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    },
    v4 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "taskSort"
    },
    v5 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantIds"
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v7 = {
      "kind": "Variable",
      "name": "filter",
      "variableName": "filter"
    },
    v8 = {
      "kind": "Variable",
      "name": "tenantIds",
      "variableName": "tenantIds"
    },
    v9 = [v7 /*: any*/, {
      "kind": "Variable",
      "name": "first",
      "variableName": "numberOfTasks"
    }, {
      "kind": "Variable",
      "name": "limit",
      "variableName": "limit"
    }, {
      "kind": "Variable",
      "name": "page",
      "variableName": "page"
    }, {
      "kind": "Variable",
      "name": "sort",
      "variableName": "taskSort"
    }, v8 /*: any*/],
    v10 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    v11 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    v12 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    v13 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v14 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    v15 = [{
      "kind": "Literal",
      "name": "first",
      "value": 100
    }],
    v16 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v17 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/],

      "kind": "Fragment",
      "metadata": null,
      "name": "useViewerQuery",
      "selections": [{
        "alias": "viewer",
        "args": null,
        "concreteType": "_Viewer",
        "kind": "LinkedField",
        "name": "_viewer",
        "plural": false,
        "selections": [v6 /*: any*/, {
          "args": v9 /*: any*/,
          "kind": "FragmentSpread",
          "name": "useTasks_tasks"
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v2 /*: any*/, v4 /*: any*/, v0 /*: any*/, v5 /*: any*/, v3 /*: any*/, v1 /*: any*/],

      "kind": "Operation",
      "name": "useViewerQuery",
      "selections": [{
        "alias": "viewer",
        "args": null,
        "concreteType": "_Viewer",
        "kind": "LinkedField",
        "name": "_viewer",
        "plural": false,
        "selections": [v6 /*: any*/, {
          "alias": null,
          "args": v9 /*: any*/,
          "concreteType": "TaskConnectionType",
          "kind": "LinkedField",
          "name": "tasks",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [v10 /*: any*/, v11 /*: any*/],

            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          }, {
            "alias": null,
            "args": [v7 /*: any*/, v8 /*: any*/],

            "concreteType": "CountGroupedByStatus",
            "kind": "LinkedField",
            "name": "countGroupedByStatus",
            "plural": true,
            "selections": [v12 /*: any*/, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }, v13 /*: any*/, v14 /*: any*/],

            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "concreteType": "TaskConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "_Task",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [v6 /*: any*/, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "descriptionText",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "titleText",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueDate",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "concreteType": "_Tenant",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [v13 /*: any*/, v6 /*: any*/],

                "storageKey": null
              }, {
                "kind": "InlineFragment",
                "selections": [{
                  "alias": "assignees",
                  "args": v15 /*: any*/,
                  "concreteType": "_AssigneeConnection",
                  "kind": "LinkedField",
                  "name": "_assignees",
                  "plural": false,
                  "selections": [{
                    "alias": null,
                    "args": null,
                    "concreteType": "_AssigneeConnectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [{
                      "alias": null,
                      "args": null,
                      "concreteType": "_Assignee",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [v6 /*: any*/, {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "actor",
                        "plural": false,
                        "selections": [v16 /*: any*/, v6 /*: any*/, v13 /*: any*/],

                        "storageKey": null
                      }, v16 /*: any*/],

                      "storageKey": null
                    }, v17 /*: any*/],

                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [v11 /*: any*/, v10 /*: any*/],

                    "storageKey": null
                  }],
                  "storageKey": "_assignees(first:100)"
                }, {
                  "alias": "assignees",
                  "args": v15 /*: any*/,
                  "filters": null,
                  "handle": "connection",
                  "key": "AssigneesPreview__assignees",
                  "kind": "LinkedHandle",
                  "name": "_assignees"
                }],
                "type": "_HasAssignees",
                "abstractKey": "__is_HasAssignees"
              }, {
                "kind": "InlineFragment",
                "selections": [{
                  "alias": "status",
                  "args": null,
                  "concreteType": "_Status",
                  "kind": "LinkedField",
                  "name": "_status",
                  "plural": false,
                  "selections": [v6 /*: any*/, v12 /*: any*/, v13 /*: any*/, {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textColor",
                    "storageKey": null
                  }, v14 /*: any*/],

                  "storageKey": null
                }],
                "type": "_HasStatus",
                "abstractKey": "__is_HasStatus"
              }, v16 /*: any*/],

              "storageKey": null
            }, v17 /*: any*/],

            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": v9 /*: any*/,
          "filters": ["sort", "filter", "tenantIds", "page", "limit"],
          "handle": "connection",
          "key": "useTasks_tasks",
          "kind": "LinkedHandle",
          "name": "tasks"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "a90b0e4c675e6ff497e3db17c62a8883",
      "id": null,
      "metadata": {},
      "name": "useViewerQuery",
      "operationKind": "query",
      "text": "query useViewerQuery(\n  $numberOfTasks: Int\n  $taskSort: [_SortInput!]\n  $filter: _FilterInput\n  $tenantIds: [ID!]\n  $page: Int\n  $limit: Int\n) {\n  viewer: _viewer {\n    id\n    ...useTasks_tasks_46266z\n  }\n}\n\nfragment AssigneesPreview__node on _HasAssignees {\n  __is_HasAssignees: __typename\n  assignees: _assignees(first: 100) {\n    edges {\n      node {\n        id\n        actor {\n          __typename\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Status__status on _HasStatus {\n  __is_HasStatus: __typename\n  status: _status {\n    id\n    identifier\n    name\n    textColor\n    color\n  }\n}\n\nfragment useTasks_tasks_46266z on _Viewer {\n  tasks(first: $numberOfTasks, sort: $taskSort, filter: $filter, tenantIds: $tenantIds, page: $page, limit: $limit) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    total\n    countGroupedByStatus(filter: $filter, tenantIds: $tenantIds) {\n      identifier\n      count\n      name\n      color\n    }\n    edges {\n      node {\n        id\n        descriptionText\n        titleText\n        dueDate\n        url\n        tenant {\n          name\n          id\n        }\n        ...AssigneesPreview__node\n        ...Status__status\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
    }
  };
}();
(node as any).hash = "ce02292af443d68b3c115b44f225dd2e";
export default node;